import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
import Trading from "@/assets/images/academy/tradingbg.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Glossary: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;

  return (
    <div className={cx(styles.glossary, className)}>
      <div className={cx(styles.glossaryContent, className)}>
        <h2>Glossary</h2>
        <ul>
          <li>
            <h4>Altcoin:</h4>
            <p>A crypto currency which is an alternative to Bitcoin</p>
          </li>
          <li>
            <h4>Decentralised Exchange (DEX):</h4>
            <p>Is a variation of cryptocurrency exchange which enables direct peer-to-peer (P2P) crypto transactions to be performed securely.</p>
          </li>
          <li>
            <h4>Fiat Currency:</h4>
            <p>Government back currency like USD or Pound</p>
          </li>
          <li>
            <h4>Initial DEX Offering (IDO):</h4>
            <p>Is a decentralised and permissionless crowdfunding platform often used to launch a new coin or token.</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default observer(Glossary);
// export default Main;
